<template>
<div id="setting-view">
        <div class="setting-content">
            <div :class="['left-container', { 'left-expand': leftExpand }]">
                <div class="header">
                    <div class="back-btn" v-show="leftExpand" @click="backToWiki">
                        <img src="@/assets/img/setting/icon_setting_back.svg"/>{{$t("返回知识库")}}                    </div>
                    <a-tooltip class="setting-expand-tooltip" :content="leftExpand ? $t('收起') : $t('展开')" background-color="#FFFFFF" :content-style="toolTipContentStyle" :arrow-style="{ display: 'none' }">
                        <div class="expand-btn" @click="leftExpand = !leftExpand">
                            <img src="@/assets/img/setting/icon_menu_expand.png"/>
                        </div>
                    </a-tooltip>
                </div>
                <div class="expand-content" v-show="leftExpand">
                    <div class="title">
                        <img v-if="wikiSpaceIcon" :src="wikiSpaceIcon"/>
                        <img v-else src="@/assets/img/setting/icon_setting_wiki.png"/>
                        <span>{{ wikiSpaceTitle }}</span>
                    </div>
                    <div class="divided"></div>
                    <div class="setting-list">
                        <div class="auth-setting" v-for="(section, idx) in settingList" :key="idx">
                            <div class="auth-setting-title">
                                <img :src="section.icon"/>
                                <span>{{ section.title }}</span>
                            </div>
                            <div :class="[
                                    'auth-setting-item',
                                    { active: currentSelect === item.id }
                                ]" v-for="(item, i) in section.items" :key="i" @click="handlerSelectSettingItem(item, i)">
                                <span>{{ item.name }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="right-container" :style="rightContainerWidth">
                <SettingHeaderView :title="rightContainerTitle"></SettingHeaderView>
                <component :is="component" @changeWikiSpaceIcon="changeWikiSpaceIcon"></component>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { intl } from 'tci18n-vue3'
import ICON_AUTH_MANAGE from '@/assets/img/setting/icon_setting_auth.png';
import ICON_AUTH_OTHER from '@/assets/img/setting/icon_setting_other.png';

import { mapActions, mapState } from 'vuex';

import SettingHeaderView from '../../components/setting/SettingHeader.vue';
import MemberAuthView from '../../components/setting/MemberAuth.vue';
import BasicInfoView from '../../components/setting/BasicInfo.vue';
import SafeSettingView from '../../components/setting/SafeSetting.vue';
import AdvancedSettingView from '../../components/setting/AdvancedSetting.vue';

import { getWikiSpaceInfo } from '../../core/api/setting';

export default {
  name: 'SettingView',
  props: {
    title: {
      type: String,
      default: intl.$t("这是知识库这是知识库这是知识库这是知识库") },

    wikiSpaceId: {
      type: String,
      default: '' } },


  components: {
    SettingHeaderView,
    MemberAuthView,
    BasicInfoView,
    SafeSettingView,
    AdvancedSettingView },

  data() {
    return {
      component: 'MemberAuthView',
      leftExpand: true,
      currentSelect: 11,
      settingList: [
      {
        title: intl.$t("权限管理"),
        icon: ICON_AUTH_MANAGE,
        items: [{ name: intl.$t("成员及权限"), id: 11 }] },

      {
        title: intl.$t("设置"),
        icon: ICON_AUTH_OTHER,
        items: [
        { name: intl.$t("基础信息"), id: 21 },
        { name: intl.$t("安全设置"), id: 22 },
        { name: intl.$t("高级设置"), id: 23 }] }],



      wikiSpaceIcon: ('' as string) };

  },
  computed: {
    ...mapState({
      wikiSpaceInfo: (state: any) => state.kbTreeNodeModule.wikiSpaceInfo }),

    wikiSpaceTitle() {
      return this.wikiSpaceInfo.wikiSpaceName;
    },
    toolTipContentStyle() {
      return {
        'font-family': 'PingFangSC-Regular',
        'font-weight': '400',
        'font-size': '14px',
        color: '#767C85',
        'letter-spacing': '0',
        'line-height': '20px' };

    },
    rightContainerWidth() {
      return this.leftExpand ?
      'width: calc(100% - 210px);' :
      'width: calc(100% - 50px);';
    },
    rightContainerTitle() {
      return this.settingList.
      find((item: any) =>
      item.items.some((i: any) => i.id === this.currentSelect))?.

      items.find((i: any) => i.id === this.currentSelect)?.name;
    } },

  mounted() {},
  created() {
    this.init();
  },
  methods: {
    ...mapActions({ setDocView: 'kbModule/setDocView' }),

    init() {
      this.getCurrentSpaceInfo();
    },

    getCurrentSpaceInfo() {
      getWikiSpaceInfo(this.wikiSpaceId).
      then((res: any) => {
        const { code, message, data } = res.data;
        if (code == 200) {
          this.nowSpaceInfo = data;
          const { wikiSpaceIcon } = this.nowSpaceInfo;
          if (wikiSpaceIcon) {
            this.wikiSpaceIcon = wikiSpaceIcon.imageUrl;
          } else {
            this.wikiSpaceIcon = this.wikiSpaceInfo.wikiSpaceIcon?.imageUrl;
          }
        } else {
          this.wikiSpaceIcon = this.wikiSpaceInfo.wikiSpaceIcon?.imageUrl;
        }
      }).
      catch((err) => {
        this.wikiSpaceIcon = this.wikiSpaceInfo.wikiSpaceIcon?.imageUrl;
      });
    },

    handlerSelectSettingItem(
    item: {id: number;name: string;},
    index: number)
    {
      this.currentSelect = item.id;
      switch (this.currentSelect) {
        case 11:
          this.component = 'MemberAuthView';
          break;
        case 21:
          this.component = 'BasicInfoView';
          break;
        case 22:
          this.component = 'SafeSettingView';
          break;
        case 23:
          this.component = 'AdvancedSettingView';
          break;
        default:
          break;}

    },

    backToWiki() {
      this.setDocView('home');
    },

    changeWikiSpaceIcon(spaceIcon: any) {
      this.wikiSpaceIcon = spaceIcon;
    } } };
</script>

<style lang="scss" scoped>
body {
    margin: 0;
    padding: 0;
    overflow: hidden;
}

#setting-view {
    width: 100%;
    height: 100vh;
    background-color: #ffffff;
}

.setting-content {
    display: flex;
    width: 100%;
    height: 100%;

    .left-container {
        width: 50px;
        height: 100%;
        background-color: #fafafb;
        box-shadow: inset -1px 0 0 0 #e8e9eb;
    }

    .left-expand {
        width: 210px;
        height: 100%;
        background-color: #fafafb;
        box-shadow: inset -1px 0 0 0 #e8e9eb;
    }

    .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 26px;
        margin: 14px 16px 16px 8px;

        .back-btn {
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #3d4757;
            letter-spacing: 0;
            line-height: 26px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            padding: 0px 5px;
            height: inherit;

            img {
                width: 16px;
                height: 16px;
                margin-right: 5px;
            }

            &:hover {
                background: #eaebec;
                border-radius: 4px;
            }
        }

        .expand-btn {
            width: 26px;
            height: 26px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            &:hover {
                background-color: #eaebec;
                border-radius: 4px;
            }

            img {
                width: 16px;
                height: 16px;
            }
        }
    }

    .title {
        padding: 8px 16px;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        img {
            width: 24px;
            height: 24px;
            margin-right: 8px;
            object-fit: cover;
            border-radius: 4px;
        }

        span {
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #3d4757;
            letter-spacing: 0;
            line-height: 24px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: left;
        }
    }

    .divided {
        width: 100%;
        height: 1px;
        background-color: #e8e9eb;
    }

    .setting-list {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        padding: 16px 8px 0 8px;

        .auth-setting {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            width: 100%;
            margin-bottom: 16px;

            .auth-setting-title {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                padding: 7px 20px 7px 20px;

                img {
                    width: 16px;
                    height: 16px;
                    margin-right: 4px;
                    object-fit: contain;
                }

                span {
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    font-size: 14px;
                    color: #646a73;
                    letter-spacing: 0;
                    line-height: 20px;
                }
            }

            .auth-setting-item {
                width: 100%;
                height: 34px;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                border-radius: 8px;
                cursor: pointer;

                span {
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    font-size: 14px;
                    color: #3d4757;
                    letter-spacing: 0;
                    line-height: 20px;
                    margin-left: 40px;
                }

                &:hover {
                    background-color: #eaebec;
                }
            }

            .active {
                background-color: #e7eaff;

                span {
                    font-family: PingFangSC-Medium;
                    font-weight: 500;
                    font-size: 14px;
                    color: #5c70ff;
                    line-height: 20px;
                }

                &:hover {
                    background-color: #e7eaff;
                }
            }
        }
    }

    .right-container {
        background-color: #ffffff;
        height: 100%;
    }
}
</style>

<style lang="scss">
.setting-expand-tooltip {
    top: 44px !important;

    .arco-trigger-content {
        padding: 0 11px !important;
        height: 36px;
        background: #ffffff;
        box-shadow: 0 8px 12px 0 #1213171a;
        border-radius: 8px;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>
